import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React from 'react';
import { Typography, Upload } from '@applyboard/ui-components';
import { getCorrectURL } from "../../util/isAbsolutePath";
export function FileUploadField(props) {
  var _props$value;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    mb: 0.5,
    variant: "caption",
    color: "secondary"
  }, "File Upload"), /*#__PURE__*/React.createElement(Upload, {
    fullWidth: true,
    onAddFiles: function onAddFiles(files) {
      props.onChange([].concat(_toConsumableArray(props.value), _toConsumableArray(files)));
    },
    files: (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.map(function (file, idx) {
      return {
        id: idx.toString(),
        name: file.name,
        size: file.size,
        contentType: file.type,
        link: !(file instanceof File) && file.link ? getCorrectURL(file.link) : null
      };
    }),
    onDeleteFile: function onDeleteFile(file) {
      props.onChange([].concat(_toConsumableArray(props.value.slice(0, Number(file.id))), _toConsumableArray(props.value.slice(Number(file.id) + 1))));
    },
    multiple: true
  }));
}